import { createFileRoute, redirect } from '@tanstack/react-router'
import { webhooksQuery } from '../../../../data/webhooks.tsx'
import { WebhookSecretForm } from '../../../../features/serviceManagement/webhooks/WebhookSecretForm.tsx'

export const Route = createFileRoute('/_app/smp/webhooks/$webhookId/secrets/create')({
	component: RouteComponent,
	loader: async (ctx) => {
		const webhooks = await ctx.context.queryClient.ensureQueryData(webhooksQuery(ctx.context.impersonation))
		const webhook = webhooks.find((wh) => wh.id === ctx.params.webhookId)
		if (!webhook) throw redirect({ to: '/smp/webhooks/{-$webhookId}', params: { webhookId: undefined } })
		return { webhook }
	},
})

function RouteComponent() {
	const { webhook } = Route.useLoaderData()
	return <WebhookSecretForm webhook={webhook} />
}
